import React, { useContext } from "react";
import Button from "@material-ui/core/Button";
import DialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";
import { Trad } from "src/components/";
import { _Dialog } from "../../components/";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

export const _AlertDialog: React.FC = () => {
    const { Dialog, HideDialog } = useContext(AlertDialogContext);

    return (
        <_Dialog
            Open={Dialog.Open}
            Title={Trad.Trad(Dialog.Title)}
            Type={Dialog.Type}
            OnClose={HideDialog}
            Actions={
                <Button onClick={HideDialog} color="primary">
                    {Trad.Trad("Chiudi")}
                </Button>
            }
        >
            <DialogContentText id="alert-dialog-description">
                <Typography variant="body2" component="span">
                    {Dialog.Content}
                </Typography>
            </DialogContentText>
        </_Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/AlertDialog.tsx